export default __webpack_public_path__ + "static/media/Q5_0.d376e484.png";